import { maxKids } from '../flow';
import { useSurvey } from '../SurveyContext';

export function KidsStep() {
  const surveyFlow = useSurvey();
  const max = maxKids(surveyFlow.answers);
  const nums: number[] = [];
  for (let i = 0; i <= max; i++) nums.push(i);
  return (
    <div className="intake-countrow">
      {nums.map((n) => (
        <button type="button"
          key={n}
          className="intake-num"
          aria-pressed={surveyFlow.answers.kidsCount === n}
          onClick={() => surveyFlow.setKids(n)}
        >
          {n}
        </button>
      ))}
    </div>
  );
}
